export default "__VITE_ASSET__9860d7b2__"